if (!customElements.get('scarlat-restock')) {
  customElements.define('scarlat-restock', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-restock-status]');
      this.setVariant(JSON.parse(this.querySelector('[data-restock-variant]').textContent));
      this.form.addEventListener('submit', (event) => this.submit(event), { signal: this.controller.signal });
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) === this.dataset.section) this.setVariant(data.variant);
      });
      this.closest('product-info')?.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]') && !event.target.value) this.setVariant(null);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.request?.abort(); this.unsubscribe?.(); }
    setVariant(variant) {
      if (String(this.variant?.id) !== String(variant?.id)) {
        this.request?.abort();
        this.querySelector('details').open = false;
        this.form.reset();
        this.status.textContent = '';
        this.form.querySelector('button').disabled = false;
      }
      this.variant = variant;
      this.hidden = !variant || variant.available;
      this.querySelector('[data-restock-title]').textContent = variant?.title === 'Default Title' ? '' : (variant?.title || '');
    }
    async submit(event) {
      event.preventDefault();
      if (!this.form.reportValidity() || !this.variant || this.variant.available) return;
      const id = String(this.variant.id);
      const button = this.form.querySelector('button');
      button.disabled = true;
      this.status.textContent = '';
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      const timeout = setTimeout(() => request.abort(), 25000);
      try {
        const data = new FormData(this.form);
        const response = await fetch('https://scarlat-frete.netlify.app/.netlify/functions/scarlat-restock-public', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: this.request.signal,
          body: JSON.stringify({ handle: this.dataset.handle, variant: id, email: data.get('email'), consent: data.get('consent') === 'on', website: data.get('website') })
        });
        const result = await response.json();
        if (id !== String(this.variant?.id)) return;
        if (!response.ok || !result.ok) throw new Error(result.error);
        this.status.textContent = this.dataset.success;
        this.form.reset();
      } catch (error) {
        if (id === String(this.variant?.id)) this.status.textContent = error.message === 'ALREADY_AVAILABLE' ? this.dataset.available : this.dataset.error;
      } finally {
        clearTimeout(timeout);
        if (id === String(this.variant?.id)) button.disabled = false;
      }
    }
  });
}
